import { SupportedChainId } from "./chains";

type AddressMap = { [chainId: number]: string }

export const GNARLY_GOATS_CONTRACT_ADDRESSES: AddressMap = {
	[SupportedChainId.MAINNET]: '0x99024D28519471909D2192218D08f7E7A916a222',
	[SupportedChainId.RINKEBY]: '0x7B698bdaa52B5FA124d97F7ED1F90D10C4fdB065',
	[SupportedChainId.ROPSTEN]: '0x99024D28519471909D2192218D08f7E7A916a222',
	[SupportedChainId.KOVAN]: '0x3A014f3102ECb916C3DAF64A0Cb64dda3FDC7A14',
	[SupportedChainId.LOCALHOST]: '0xae810028836cB8CcBc1AdC6878C294c9357909f7',
}

export const GNARLY_GOATS_MINT_PASS_CONTRACT_ADDRESSES: AddressMap = {
	[SupportedChainId.MAINNET]: '0x99024D28519471909D2192218D08f7E7A916a222',
	[SupportedChainId.RINKEBY]: '0x4aD78Cb4b6c35277f42dAA857eD4b7A6d332A977',
	[SupportedChainId.ROPSTEN]: '0x99024D28519471909D2192218D08f7E7A916a222',
	[SupportedChainId.KOVAN]: '0x3A014f3102ECb916C3DAF64A0Cb64dda3FDC7A14',
	[SupportedChainId.LOCALHOST]: '0xA9A7d3AA0A1768c2b41aa9154efC45e845d59Cd1',
}
